const flags = {
  actionMenu2: true,
  agGridIsStrict: true,
  mdfButton2: true,
  waypointCards: true,
  waypointModal: true,
  waypointSlideIn: true,
  wfnHtml2Pdf: true
};

export class FeatureFlags {
  static hasFeature(featureName: string) {
    const flagValue = localStorage.getItem(featureName);

    if (flagValue === 'off') {
      this.disableFeature(featureName);
      return false;
    }
    else if (flagValue === 'on') {
      this.useFeature(featureName);
      return true;
    }
    else {
      return !!flags[featureName];
    }
  }

  static useFeature(featureName: string) {
    flags[featureName] = true;
    localStorage.setItem(featureName, 'on');
  }

  static disableFeature(featureName: string) {
    flags[featureName] = false;
    localStorage.removeItem(featureName);
  }
}
